var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegramLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#8F92A1",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61081 12.2244L8.36967 13.2531L9.44515 16.7134C9.49191 16.9472 9.77247 16.9939 9.95951 16.8537L11.5026 15.5911C11.6429 15.4509 11.8767 15.4509 12.0637 15.5911L14.8226 17.6018C15.0096 17.7421 15.2902 17.6486 15.3369 17.4148L17.3944 7.59514C17.4411 7.36134 17.2073 7.12755 16.9735 7.22107L5.61081 11.6165C5.33025 11.71 5.33025 12.1309 5.61081 12.2244ZM9.30487 12.7388L14.729 9.41879C14.8226 9.37203 14.9161 9.51231 14.8226 9.55907L10.3804 13.7207C10.2401 13.861 10.0998 14.048 10.0998 14.2818L9.95951 15.4041C9.95951 15.5444 9.72571 15.5911 9.67895 15.4041L9.11782 13.3466C8.97754 13.1128 9.07107 12.8323 9.30487 12.7388Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramLogo);
export default __webpack_public_path__ + "static/media/telegramLogo.1ce15604363a1b8749286e6b51b1e910.svg";
export { ForwardRef as ReactComponent };